import { render, staticRenderFns } from "./IDC.vue?vue&type=template&id=760b9d78&"
import script from "./IDC.vue?vue&type=script&lang=js&"
export * from "./IDC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports